/**
 * @jsxRuntime classic
 * @jsx jsx
 *
 * Hoisted icon render functions (stable references) — required by AFM perf lint
 * rule `@atlassian/perf-linting/no-unstable-inline-props`. The IconButton/Button
 * `icon` / `iconBefore` props must be stable across renders to avoid React tree
 * rerenders for the icon component itself.
 *
 * Keeping every icon used by the Post Stream Review toolbar in a single file
 * means consumers (the action-button cluster) need only one import.
 *
 * Explicit `JSX.Element` return annotations are required by `--isolatedDeclarations`.
 */

import { jsx } from '@compiled/react';

import CheckMarkIcon from '@atlaskit/icon/core/check-mark';
import ChevronLeftIcon from '@atlaskit/icon/core/chevron-left';
import ChevronRightIcon from '@atlaskit/icon/core/chevron-right';
import EyeOpenIcon from '@atlaskit/icon/core/eye-open';
import EyeOpenStrikethroughIcon from '@atlaskit/icon/core/eye-open-strikethrough';
import RedoIcon from '@atlaskit/icon/core/redo';
import UndoIcon from '@atlaskit/icon/core/undo';
import { token } from '@atlaskit/tokens';

import { StepThroughIcon } from '../../../../icons/stepThrough';

/** Green check shown in the "Accepted" confirmation pill (decorative — the pill's text carries the meaning). */
export const renderAcceptedCheckIcon = (): JSX.Element => (
	<CheckMarkIcon label="" color={token('color.icon.success')} />
);
export const renderUndoIcon = (): JSX.Element => <UndoIcon label="" />;
export const renderRedoIcon = (): JSX.Element => <RedoIcon label="" />;
export const renderEyeOpenIcon = (): JSX.Element => <EyeOpenIcon label="" />;
export const renderEyeOpenStrikethroughIcon = (): JSX.Element => (
	<EyeOpenStrikethroughIcon label="" />
);
export const renderFullscreenEnterIcon = (): JSX.Element => <StepThroughIcon />;
export const renderChevronLeftIcon = (): JSX.Element => <ChevronLeftIcon label="" size="small" />;
export const renderChevronRightIcon = (): JSX.Element => <ChevronRightIcon label="" size="small" />;
